import React, { createContext, useContext } from 'react'

import { Report } from '../report.model'

const ReportTocContext = createContext()

export const useReportTocContext = function () {
  return useContext(ReportTocContext)
}

class ReportTocChanges {
  constructor (report) {
    this.report = report
    this.changes = {}
  }

  setNewType (type) {
    this.changes.type = type
  }

  setNewTitle (title) {
    this.changes.title = title
  }

  setNewDescription (description) {
    this.changes.description = description
  }

  setNewGroups (groups) {
    this.changes.groups = groups
  }

  clearChanges () {
    this.changes = {}
  }

  getChangesParams () {
    const params = {}

    if (this.changes.title) {
      params.title = this.changes.title
    }

    if (this.changes.type) {
      params.type = this.changes.type
    }

    if (this.changes.description) {
      params.description = this.changes.description
    }

    if (this.changes.groups) {
      params.groups = Report.formatGroupsForServer(this.changes.groups)
    }

    return params
  }
}

export const ReportTocContextProvider = function ({ report, children }) {
  const reportToc = new ReportTocChanges(report)
  return (
    <ReportTocContext.Provider value={reportToc}>
      {children}
    </ReportTocContext.Provider>
  )
}
